export default "__VITE_PUBLIC_ASSET__f3b7f324__"